import { render, staticRenderFns } from "./OrgSettings.vue?vue&type=template&id=45f59714&scoped=true"
import script from "./OrgSettings.vue?vue&type=script&lang=js"
export * from "./OrgSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f59714",
  null
  
)

export default component.exports